import React, { useEffect, useState } from "react";

const headers = () => {
  const t = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
  return { "Content-Type": "application/json", Authorization: "Bearer " + t };
};

const EMPTY = { displayName: "", logoUrl: "", faviconUrl: "", primaryColor: "", secondaryColor: "", footerText: "", tagline: "" };
const inp = { padding: "8px 12px", width: "100%", boxSizing: "border-box", borderRadius: 6, border: "1px solid var(--border)", background: "var(--bg-elevated)", color: "var(--text-main)", fontSize: 14 };
const lab = { display: "block", margin: "14px 0 4px", fontSize: 11, fontWeight: 600, textTransform: "uppercase", color: "var(--text-muted)" };
const isHex = (s) => /^#[0-9A-Fa-f]{6}$/.test(s || "");

const Field = ({ label, hint, children }) => (
  <div>
    <label style={lab}>{label}</label>
    {children}
    {hint && <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 4 }}>{hint}</div>}
  </div>
);

const PartnerBrandingTab = () => {
  const [f, setF] = useState(EMPTY);
  const [loaded, setLoaded] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  useEffect(() => {
    fetch("/api/partner-admin/branding", { headers: headers() })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok && d.data) setF({ ...EMPTY, ...d.data });
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  const [upBusy, setUpBusy] = useState("");
  const upload = (kind, file) => {
    if (!file) return;
    setUpBusy(kind);
    setErr("");
    setMsg("");
    const fd = new FormData();
    fd.append("file", file);
    const tk = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
    fetch("/api/partner-admin/branding/upload?kind=" + kind, { method: "POST", headers: { Authorization: "Bearer " + tk }, body: fd })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok) {
          setF((p) => ({ ...p, [kind === "logo" ? "logoUrl" : "faviconUrl"]: d.url }));
          setMsg("Image uploaded and applied. Refresh the page to see it everywhere.");
        } else {
          setErr(d.error || "Upload failed");
        }
      })
      .catch(() => setErr("Upload failed"))
      .finally(() => setUpBusy(""));
  };
  const uploadBtn = (kind) => (
    <div style={{ marginTop: 8 }}>
      <label style={{ display: "inline-block", padding: "6px 14px", borderRadius: 6, border: "1px solid var(--border)", cursor: upBusy ? "default" : "pointer", fontSize: 12, fontWeight: 600, color: "var(--text-main)" }}>
        {upBusy === kind ? "Uploading..." : "Upload image"}
        <input type="file" accept={kind === "favicon" ? "image/png,image/jpeg,image/webp,image/x-icon,.ico" : "image/png,image/jpeg,image/webp"} style={{ display: "none" }} disabled={!!upBusy} onChange={(e) => { upload(kind, e.target.files && e.target.files[0]); e.target.value = ""; }} />
      </label>
    </div>
  );
  const save = () => {
    setBusy(true);
    setErr("");
    setMsg("");
    fetch("/api/partner-admin/branding", { method: "PUT", headers: headers(), body: JSON.stringify(f) })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok) {
          setMsg("Saved. The page will reload to apply your branding.");
          setTimeout(() => window.location.reload(), 1500);
        } else {
          setErr(d.error || "Failed");
        }
      })
      .catch(() => setErr("Failed"))
      .finally(() => setBusy(false));
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <h3 style={{ color: "var(--text-main)", marginTop: 0 }}>Community branding</h3>
      <p style={{ color: "var(--text-muted)", fontSize: 14, lineHeight: 1.5 }}>
        Your community name, logo and colors are shown to your members on the landing page, sign-in pages and dashboards. Leave a field empty to remove it.
      </p>
      {msg && <div style={{ background: "var(--success)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 12, display: "inline-block" }}>{msg}</div>}
      {err && <div style={{ background: "var(--danger)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 12, display: "inline-block" }}>{err}</div>}
      {!loaded ? (
        <div style={{ color: "var(--text-muted)" }}>Loading...</div>
      ) : (
        <div>
          <Field label="Community name" hint="2 to 60 characters">
            <input style={inp} value={f.displayName} onChange={set("displayName")} />
          </Field>
          <Field label="Logo link" hint="Upload a PNG, JPG or WebP image (max 500 KB), or paste a public https link to your logo">
            <input style={inp} value={f.logoUrl} onChange={set("logoUrl")} placeholder="https://..." />
            {uploadBtn("logo")}
            {(f.logoUrl.startsWith("https://") || f.logoUrl.startsWith("/api/partner/assets/")) && <img src={f.logoUrl} alt="" style={{ height: 40, marginTop: 8, objectFit: "contain" }} onError={(e) => (e.target.style.display = "none")} />}
          </Field>
          <Field label="Favicon link" hint="Small icon for the browser tab. Upload a PNG, JPG, WebP or ICO image (max 500 KB), or paste an https link">
            <input style={inp} value={f.faviconUrl} onChange={set("faviconUrl")} placeholder="https://..." />
            {uploadBtn("favicon")}
          </Field>
          <Field label="Main color" hint="Example: #1A2B3C">
            <input style={{ ...inp, width: 160 }} value={f.primaryColor} onChange={set("primaryColor")} placeholder="#1A2B3C" />
            {isHex(f.primaryColor) && <span style={{ display: "inline-block", width: 24, height: 24, borderRadius: 4, marginLeft: 8, verticalAlign: "middle", background: f.primaryColor }} />}
          </Field>
          <Field label="Secondary color" hint="Optional">
            <input style={{ ...inp, width: 160 }} value={f.secondaryColor} onChange={set("secondaryColor")} placeholder="#1A2B3C" />
            {isHex(f.secondaryColor) && <span style={{ display: "inline-block", width: 24, height: 24, borderRadius: 4, marginLeft: 8, verticalAlign: "middle", background: f.secondaryColor }} />}
          </Field>
          <Field label="Tagline" hint="Short line shown under your name, for example: Signals for our community. Leave empty to show no tagline. Up to 80 characters">
            <input style={inp} value={f.tagline} onChange={set("tagline")} />
          </Field>
          <Field label="Footer text" hint="Up to 200 characters">
            <input style={inp} value={f.footerText} onChange={set("footerText")} />
          </Field>
          <div style={{ marginTop: 20 }}>
            <button disabled={busy} onClick={save} style={{ padding: "8px 20px", borderRadius: 6, border: "none", cursor: busy ? "default" : "pointer", fontWeight: 700, fontSize: 13, background: "var(--accent)", color: "#fff" }}>Save</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerBrandingTab;
